import React from 'react';

const FileInput = ({ label, name, onChange }) => (
  <div className="mb-4">
    <label>
      {label}<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
    </label>
    <input
      type="file"
      name={name}
      onChange={onChange}
      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-blue-600"
    />
  </div>
);

export default FileInput;